import { useEffect, useState } from "react";
import icoDownload from '../../assets/img/ico-download.svg';
import api from "../Services/api";

const DocumentLink = (props: any) => {
  const { useURLImg = false, imageMapping = {} } = props;
  const [file, setFile] = useState<any[]>([]);
  useEffect(() => {

    api.get(props.url)
      .then(response => {
        response?.data?.results?.sort((a: any, b: any) => a.Ordem - b.Ordem);
        setFile(response?.data?.results);
      })
      .catch(error => {
        throw new Error(error);
      });
  }, [props.url]);

  console.log("Documento completo 0: ", file[0]);
  console.log("Documento completo 1: ", file[1]);


  return (
    <>
      {file?.map((item, index) => (
        <div key={index} className="col-md-6 col-lg-5">
          <div className="box-pdf mt-4 mb-5">
            <a rel="noreferrer" href={item.URL} target="_blank" className="d-block">
              <img
                src={
                  (useURLImg && imageMapping[item.Title])
                    ? imageMapping[item.Title]
                    : (useURLImg && item?.URLImg && item.URLImg.trim() !== '')
                      ? item.URLImg
                      : (item?.Imgurl ?? props.fileImg)
                }
                alt={item.Title || "Documento"}
                className="mb-5 w-100"
              />
            </a>
            <div className="container">
              <div className="row">
                <div className="col-xs-6">
                  <strong>{item.Title}</strong>
                </div>
                <div className="col-xs-6">
                  <div className="card-comunicado__btn">
                    <a rel="noreferrer" href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
                      <img style={{ maxWidth: "55%" }} src={icoDownload} alt="Ícone" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      <hr style={{ width: '100%' }}></hr>
    </>
  )
};
export default DocumentLink;